import api from './api';
import { API_COMMANDS } from './commands';

const makePayments = async (paymentsParam) => {
  const response = await api.post('', paymentsParam, {
    params: { command: API_COMMANDS.PAYMENT_MAKE },
  });
  return response.data;
};

export default makePayments;
